<template>
  <div class="supplierMaintenanceList">
    <div class="header">
      <img
        src="@/assets/img/login/logo.png"
        alt="智生活 Logo"
      >
    </div>
    <div class="body">
      <Category
        v-for="item in categoryList"
        :key="item.Category"
        :data="item"
      />
      <div
        v-if="!isLoading && categoryList.length === 0"
        class="empty"
      >
        目前無待維養項目
      </div>
    </div>
  </div>
</template>

<script>
import { apiAsset } from '../../api/smartBuildingSystemAPI'
import Category from './components/Category'
import jwt_decode from 'jwt-decode'
import { goToSupplierMaintenance401 } from './js'

export default {
  components: {
    Category
  },
  data () {
    const isLoading = true
    const categoryList = []
    return {
      isLoading,
      categoryList
    }
  },
  async mounted () {
    try {
      const jwt = this.$route.query.jwt
      let decodedJwt
      try {
        decodedJwt = jwt_decode(jwt)
      } catch (error) {
        console.log(error)
        goToSupplierMaintenance401()
      }
      const supplierId = decodedJwt.SupplierId
      const communityId = decodedJwt.CommunityId
      const { data } = await apiAsset.maintenance.getSupplierMaintenanceList(supplierId, communityId, jwt)
      this.categoryList = data
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.supplierMaintenanceList {
  width: 100%;
  height: 100vh;
  max-height: -webkit-fill-available;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  .header {
    flex: 0 0 64px;
    background-color: $mainColor;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 39px;
    }
  }
  .body {
    flex-grow: 1;
    padding: 36px 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-y: scroll;
    .empty {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
